// Received by densu, job not started
import { useEffect, useState, useRef } from 'react';
import { jobStatusAPI } from '../../../api/jobStatusAPI';

import './receiveByDensuModal.css';

export default function ReceiveByDensuModal() {
    const [jobCount, setjobCount] = useState('...');
    const [jobsDetails, setjobsDetails] = useState([]);

    const didMount = useRef(false);

    useEffect(() => {
        if (!didMount.current) {
            didMount.current = true;
            jobStatusAPI.getPickupReceived().then((data) => {
                setjobCount(data.pendingJobTotal);
                setjobsDetails(data.details);
            });
        }
    }, [])

    return (
        <>
            <button type="button" class="form-control btn btn-primary" data-bs-toggle="modal" data-bs-target="#modalNum03" >{jobCount}</button>

            <div className='row'>
                <div class="modal fade" id="modalNum03" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg modal-xl">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Received by Densu (Pending job start)</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                <div className='row'>
                                    <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-2 table-responsive-sm table-responsive-md '>
                                        <table className="table table-bordered text-start">
                                            <thead className="thead--color ">
                                                <tr>
                                                    <th className="num_W">#</th>
                                                    <th className="col_W">Received Date</th>
                                                    <th className="col_W text-end">Normal Qty</th>
                                                    <th className="col_W text-end">Urgent Qty</th>
                                                    <th className="col_W text-end">Repeat Qty</th>
                                                    <th className="col_W text-end">Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    jobsDetails.map((le, index) => (
                                                        <tr key={index}>
                                                            <td className='col_We'>{le.refNo}</td>
                                                            <td className='col_We'>{le.refDate}</td>
                                                            <td className='col_We text-end'>{le.normalQty}</td>
                                                            <td className='col_We text-end'>{le.urgentQty}</td>
                                                            <td className='col_We text-end'>{le.repeatQty}</td>
                                                            <td className='col_We text-end'>{+le.normalQty + +le.urgentQty + +le.repeatQty}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}